import * as React from "react";
import Layout from "./containers/Layout.tsx";
import { theme } from "./theme.ts";

import { ThemeProvider } from "@mui/material/styles";

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Layout />
    </ThemeProvider>
  );
}
